import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import PassengerCodeOfConductText from './PassengerCodeOfConductText';
import './PilotCodeOfConductModal.css';

export default function PassengerCodeOfConductModal({ onClose }) {
  const { t } = useTranslation();

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [onClose]);

  return createPortal(
    <div
      className="pilot-code-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="passenger-code-modal-title"
      onClick={onClose}
    >
      <div
        className="pilot-code-modal card pilot-code-modal--passenger"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="passenger-code-modal-title" className="pilot-code-modal-heading">
          {t('costSharing.passengerConductModalTitle')}
        </h2>
        <div className="pilot-code-modal-scroll">
          <PassengerCodeOfConductText showTitle />
        </div>
        <div className="pilot-code-modal-actions">
          <button type="button" className="btn btn-primary" onClick={onClose}>
            {t('costSharing.passengerConductClose')}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
